"use client";

import * as React from "react";

import { createSVGIcon } from "../util";

const VIEWBOX = "0 0 24 24";

/**
 * @trackcomponent
 * @donotsync shifts upwards (@quinlan.sokol)
 * @optimized using svgo:^3.0.2
 */
export const Minimize = createSVGIcon(
  <path
    d="m1 23.286 8.571-8.571M2.714 14.715h6.858v6.857M23.286 1l-8.572 8.571M21.572 9.572h-6.858V2.715"
    stroke="currentColor"
  />,
  "Minimize",
  (strictLocalize) => ({
    viewBox: VIEWBOX,
    titleAccess: strictLocalize({
      defaultMessage: "Minimize",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
  })
);
